<template>
  <div class="progress-bar-container">
    <span class="progress-text">{{ progress }}%</span>
    <div class="loader-bar">
      <div class="block-border" v-for="(block, index) in blockBorders" :key="'border-' + index"></div>
      <div
          v-for="(block, index) in blockMeters"
          :key="'meter-' + index"
          class="block-meter"
          :class="{ 'visible': block.visible, 'blinking': block.blinking }"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['reward', 'dailyStf', 'interval']),
    progress() {
      const reward = parseFloat(this.reward);
      const dailyStf = parseFloat(this.dailyStf);
      const interval = parseFloat(this.interval);

      // 86400 saniyede alınabilecek maksimum ödülü hesapla
      const maxRewardInInterval = (dailyStf / 86400) * interval;

      // Mevcut ödül yüzdesi
      return ((reward / maxRewardInInterval) * 100).toFixed(2);
    },
    blockMeters() {
      const totalBlocks = 10;
      const progressPerBlock = 100 / totalBlocks;
      const filledBlocks = Math.ceil(this.progress / progressPerBlock);

      if (parseFloat(this.progress) >= 100) {
        this.$store.commit('STOP_VIRTUAL_BALANCE_UPDATE');
        this.$store.commit('START_LOST_REWARD_UPDATE');
        this.$store.commit('SET_CLAIM_BUTTON_ACTIVE', true);
      }

      return Array(totalBlocks)
          .fill(false)
          .map((_, i) => ({
            visible: i < filledBlocks,
            blinking: i === filledBlocks - 1 && this.progress < 100
          }));
    },
    blockBorders() {
      return Array(8).fill(true);
    }
  },
  watch: {
    progress(newProgress) {
      this.updateProgress(newProgress);
    }
  },
  methods: {
    updateProgress(newProgress) {
      const totalBlocks = 10;
      const progressPerBlock = 100 / totalBlocks;
      const filledBlocks = Math.ceil(newProgress / progressPerBlock);

      this.blockMeters.forEach((block, index) => {
        if (index < filledBlocks) {
          block.visible = true;
          block.blinking = index === filledBlocks - 1 && newProgress < 100;
        } else {
          block.visible = false;
          block.blinking = false;
        }
      });
/*
      if (newProgress >= 100) {
        this.$store.commit('STOP_VIRTUAL_BALANCE_UPDATE');
        this.$store.commit('START_LOST_REWARD_UPDATE');
        this.$store.commit('SET_CLAIM_BUTTON_ACTIVE', true);
      }*/
    }
  },
  /*mounted() {
    if (parseFloat(this.progress) >= 100) {
      this.$store.commit('STOP_VIRTUAL_BALANCE_UPDATE');
      this.$store.commit('START_LOST_REWARD_UPDATE');
      this.$store.commit('SET_CLAIM_BUTTON_ACTIVE', true);
    }
  },*/
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.updateProgress(vm.progress);
    });
  }
};
</script>

<style scoped>
.progress-bar-container {
  margin: 20px 0;
}
.progress-text {
  font-size: 28px;
  font-family: 'Digital-7', sans-serif;
  font-weight: 700;
}
.loader-bar {
  width: 60vw;
  height: 12vw;
  display: grid;
  grid-template-columns: repeat(3, 2vw) repeat(10, 3vw 2vw) repeat(2, 2vw);
  grid-template-rows: repeat(6, 2vw);
}
.block-border {
  background-color: #040C14;
}
.block-meter {
  background-color: rgb(100, 200, 100);
  opacity: 0;
  transition: opacity 2s linear;
}
.block-border:nth-of-type(1) {
  grid-row: 1;
  grid-column: 3/-3;
}
.block-border:nth-of-type(2) {
  grid-row: -2;
  grid-column: 3/-3;
}
.block-border:nth-of-type(3) {
  grid-row: 3/5;
  grid-column: 1;
}
.block-border:nth-of-type(4) {
  grid-row: 3/5;
  grid-column: -2;
}
.block-border:nth-of-type(5) {
  grid-row: 2;
  grid-column: 2;
}
.block-border:nth-of-type(6) {
  grid-row: 2;
  grid-column: -3;
}
.block-border:nth-of-type(7) {
  grid-row: 5;
  grid-column: 2;
}
.block-border:nth-of-type(8) {
  grid-row: 5;
  grid-column: -3;
}
.block-meter:nth-of-type(9) {
  grid-row: 3/5;
  grid-column: 4;
  opacity: 0;
}
.block-meter:nth-of-type(10) {
  grid-row: 3/5;
  grid-column: 6;
  opacity: 0;
}
.block-meter:nth-of-type(11) {
  grid-row: 3/5;
  grid-column: 8;
  opacity: 0;
}
.block-meter:nth-of-type(12) {
  grid-row: 3/5;
  grid-column: 10;
  opacity: 0;
}
.block-meter:nth-of-type(13) {
  grid-row: 3/5;
  grid-column: 12;
  opacity: 0;
}
.block-meter:nth-of-type(14) {
  grid-row: 3/5;
  grid-column: 14;
  opacity: 0;
}
.block-meter:nth-of-type(15) {
  grid-row: 3/5;
  grid-column: 16;
  opacity: 0;
}
.block-meter:nth-of-type(16) {
  grid-row: 3/5;
  grid-column: 18;
  opacity: 0;
}
.block-meter:nth-of-type(17) {
  grid-row: 3/5;
  grid-column: 20;
  opacity: 0;
}
.block-meter:nth-of-type(18) {
  grid-row: 3/5;
  grid-column: 22;
  opacity: 0;
}
.block-meter:nth-of-type(19) {
  grid-row: 3/5;
  grid-column: 24;
  opacity: 0;
}
.block-meter.visible {
  opacity: 1;
}
.block-meter.blinking {
  animation: blink 1s linear infinite;
}
@keyframes blink {
  50% {
    opacity: 0.5;
  }
}
</style>
